import React, { useEffect, useState } from "react";
import styles from "../../pages/diviner-signup/payment.module.css";
import Head from "next/head";
import states from "../json/state.json";
import countries from "../json//countries.json";
import indianStates from "../json/IndianState.json";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Alert,
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  LinearProgress,
  MenuItem,
  Modal,
  Select,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import PaymentComponent from "../../pages/diviner-signup/CardElement";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import CloseIcon from "@mui/icons-material/Close";
import { useRouter } from "next/router";
import { loadStripe } from "@stripe/stripe-js";
import { v4 as uuidv4 } from "uuid";
import { getCookie, setCookie } from "../utils/cookie";
import Cookies from "js-cookie";
import { Elements } from "@stripe/react-stripe-js";
import StripePaymentModal from "../Modal/StripePaymentModal";

const DivinerSighnUp = () => {
  const [user, setUser] = useState({
    personal_details: {},
    payment_detais: {},
  });
  const [error, setError] = useState({});
  const [passwordVition, setPasswardVition] = useState(false);
  const [con_passwordVition, setCon_PasswardVition] = useState(false);
  const [personalLoader, setPersonalLoader] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [snackbarState, setSnackbarState] = useState(false);
  const [snackbarMassage, setSnackbarMassage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [personalFormData, setPersonalFormData] = useState({});
  const [ip, setIp] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [stripeProcessing, setStripeProcessing] = useState(false);
  const [stripeError, setStripeError] = useState(null);
  const [isStripeModalOpen, setIsStripeModalOpen] = useState(false);
  const [allPriceCurrencyData, setAllPriceCurrencyData] = useState({});
  const [amountAndType, setAmountAndType] = useState({
    type: "Full",
    amount: 497,
  });
  const [stateJson, setStateJson] = useState(states);
  const [plans, setPlans] = useState([]);
  const [selectedPlanIndex, setSelectedPlanIndex] = useState(0);
  const [loadingPlans, setLoadingPlans] = useState(true);

    
  const handleOpen = () => setOpen(true);
  const handleCloseNew = () => setOpen(false);

  const uuid = uuidv4();
  const router = useRouter();
  const params = router.query;

  useEffect(() => {
    let obj = { ...user };
    obj["personal_details"]["user_type"] = "is_trainee";
    obj["personal_details"]["country"] = "USA";
    setUser(obj);

    const fetchIp = async () => {
      const res = await fetch("https://ipinfo.io/json?token=32b3c233366230");
      const data = await res.json();
      setIp(data);
    };
    fetchIp();

    const fetchPlans = async () => {
      try {
        // Call local Next.js API proxy to avoid CORS (proxies to astrologypro.com server-side)
        const res = await fetch(`/api/pricing/professional_divination_course`);
        const data = await res.json();
        console.log("Pricing API Response:", data); // debug
        // Handle different possible response shapes
        const plansArray = Array.isArray(data.plans)
          ? data.plans
          : Array.isArray(data.results?.plans)
            ? data.results.plans
            : Array.isArray(data)
              ? data
              : null;
        if (plansArray && plansArray.length > 0) {
          const baseAmount = plansArray[0]?.amount || 1;
          const mappedPlans = plansArray.map((p) => ({
            ...p,
            name: p.display_name || p.name || p.plan_id,
            description: p.description || "",
            priceMultiplier: p.amount / baseAmount || 1,
            stripe_price_id: p.stripe_price_id,
          }));
          setPlans(mappedPlans);
        } else {
          console.warn("No plans found in pricing API response:", data);
        }
      } catch (err) {
        console.error("Error fetching pricing plans:", err);
      } finally {
        setLoadingPlans(false);
      }
    };
    fetchPlans();
  }, []);

  useEffect(() => {
    const fetchPrice = async (countryval) => {
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}wheel_signs/find-divination-certificate-price`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ place: countryval }),
        }
      );
      const data = await res.json();
      setAllPriceCurrencyData(data.response?.response);

      setAmountAndType({
        type: "Full",
        amount:
          countryval == "India"
            ? data.response?.response.india_price.price
            : data.response?.response.usa_price.price,
        currency:
          countryval == "India"
            ? data.response?.response.india_price.currency
            : data.response?.response.usa_price.currency,
      });
    };

    if (Object.keys(ip).length > 0) {
      let countryval = ip?.country === "IN" ? "India" : "USA";
      // Only set the regional price as initial amount, plan selection overrides this
      fetchPrice(countryval);
      setUser((prev) => ({
        ...prev,
        personal_details: { ...prev.personal_details, country: countryval },
      }));
      setStateJson(
        countryval === "India"
          ? indianStates
          : countryval === "USA"
            ? states
            : states
      );
    }
  }, [ip]);

  useEffect(() => {
    if (ip && params) {
      callipcall(params.affiliatid);
    }
  }, [ip, params]);

  const callipcall = async (_id) => {
    let requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ affiliate_id: _id }),
    };

    let req = await fetch(
      `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}user/find-affiliate-id`,
      requestOptions
    );
    let res = await req.json();
    if (res.status === "success") {
      let uu_id = uuid;
      setCookie("uuid", uu_id, {});
      let obj = {
        uuid: uu_id,
        ip_info: { ...ip },
        affiliate_id: res.res,
      };
      let requestOptionsconvert = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(obj),
      };
      let reqconvert = await fetch(
        `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}user/click-conversion-report-add-update`,
        requestOptionsconvert
      );
      let resconvert = await reqconvert.json();
    }
  };

  const handleInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let obj = { ...user };


    if (name === "firstname") {
      obj["personal_details"]["firstname"] = value;
    }
    if (name === "lastname") {
      obj["personal_details"]["lastname"] = value;
    }
    if (name === "contact_number") {
      obj["personal_details"]["contact_number"] = value;
    }
    if (name === "billingaddress") {
      obj["personal_details"]["billingaddress"] = value;
    }
    if (name === "city") {
      obj["personal_details"]["city"] = value;
    }
    if (name === "state") {
      obj["personal_details"]["state"] = value;
      setError({ ...error, [name]: undefined });
    }
    if (name === "zip") {
      obj["personal_details"]["zip"] = value;
    }
    if (name === "email") {
      obj["personal_details"]["email"] = value.replace(/\s+/g, "");
    }
    if (name === "country") {
      obj["personal_details"]["state"] = "";

      setUser({ ...obj });

      if (value === "India") {
        setStateJson(indianStates);
        setAmountAndType({
          type: "Full",
          amount: allPriceCurrencyData.india_price.price,
          currency: allPriceCurrencyData.india_price.currency,
        });
      } else if (value === "USA") {
        setStateJson(states);
        setAmountAndType({
          type: "Full",
          amount: allPriceCurrencyData.usa_price.price,
          currency: allPriceCurrencyData.usa_price.currency,
        });
      } else {
        setStateJson([]);
        setAmountAndType({
          type: "Full",
          amount: allPriceCurrencyData.usa_price.price * (plans[selectedPlanIndex]?.priceMultiplier || 1),
          currency: allPriceCurrencyData.usa_price.currency,
        });
      }

      obj["personal_details"]["country"] = value;
    }
    if (name === "password") {
      obj["personal_details"]["password"] = value;
    }
    if (name === "confirm_password") {
      obj["personal_details"]["confirm_password"] = value;
    }

    setUser({ ...obj });
  };

  const phoneFormatting = (event) => {
    if (event.target.value.split("").length <= 14) {
      let formatted = formatPhoneText(event.target.value);
      let name = event.target.name;
      let obj = { ...user };
      obj["personal_details"]["phone"] = formatted;
      setUser(obj);
    }
  };

  function formatPhoneText(value) {
    value = value.trim().replaceAll("-", "");
    value = value.trim().replaceAll("(", "");
    value = value.trim().replaceAll(")", "");
    value = value.trim().replaceAll(" ", "");

    if (value.length > 3 && value.length <= 6)
      value = "(" + value.slice(0, 3) + ")" + " " + value.slice(3);
    else if (value.length > 6)
      value =
        "(" +
        value.slice(0, 3) +
        ")" +
        " " +
        value.slice(3, 6) +
        "-" +
        value.slice(6);
    return value;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errorObject = {};

    if (!user?.personal_details?.firstname) {
      errorObject.firstname = "First Name is Required";
    }
    if (!user?.personal_details?.lastname) {
      errorObject.lastname = "Last Name is Required";
    }
    if (!user?.personal_details?.phone) {
      errorObject.phone = "Contact Number is Required";
    } else if (user?.personal_details?.phone.length < 10) {
      errorObject.phone = "Please input a valid phone number";
    }
    if (!user?.personal_details?.billingaddress) {
      errorObject.billingaddress = "Billing Address is Required";
    }
    if (!user?.personal_details?.city) {
      errorObject.city = "City is Required";
    }
    if (!user?.personal_details?.state) {
      errorObject.state = "State is Required";
    }
    if (!user?.personal_details?.zip) {
      errorObject.zip = "Zip is Required";
    }
    if (!user?.personal_details?.email) {
      errorObject.email = "Email is Required";
    } else if (!/\S+@\S+\.\S+/.test(user?.personal_details.email)) {
      errorObject.email = "* Invalid email format";
    }
    if (!user?.personal_details?.country) {
      errorObject.country = "Country is Required";
    }
    if (!user?.personal_details?.password) {
      errorObject.password = "Password is Required";
    } else if (
      !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).{8,15}$/.test(
        user?.personal_details.password
      )
    ) {
      errorObject.password = "* Invalid Password";
    }
    if (!user?.personal_details?.confirm_password) {
      errorObject.confirm_password = "Confirm Password is Required";
    }
    if (
      user?.personal_details?.password &&
      user?.personal_details?.confirm_password &&
      user?.personal_details?.password !==
      user?.personal_details?.confirm_password
    ) {
      errorObject.confirm_password =
        "Password and Confirm Password do not match";
    }

    if (user?.personal_details?.firstname && user?.personal_details?.lastname) {
      setUser({
        ...user,
        name: `${user.personal_details.firstname} ${user.personal_details.lastname}`,
      });
    }

    if (Object.keys(errorObject).length > 0) {
      setError(errorObject);
    } else {
      setError({});
      const uuidVal = getCookie("uuid");

      if (params.affiliatid) {
        try {
          let requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ affiliate_id: params.affiliatid }),
          };

          let req = await fetch(
            `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}user/find-affiliate-id`,
            requestOptions
          );
          let res = await req.json();

          await fetchPersonalData({
            ...user.personal_details,
            affiliate_id: res.res,
            uuid: uuidVal,
          });
        } catch (error) {
          setSnackbarSeverity("error");
          setSnackbarMassage("Failed to process affiliate information");
          setSnackbarState(true);
        }
      } else {
        await fetchPersonalData(user.personal_details);
      }
    }
  };

  const fetchPersonalData = async (val) => {
    setPersonalLoader(true);
    try {
      const signupPayload = { ...val, is_diviner: 0 };

      let requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(signupPayload),
      };
      // return
      let req = await fetch(
        `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}user/trainee-signup`,
        requestOptions
      );
      let res = await req.json();
      let obj = { ...user.personal_details };
      if (res.status === "success") {
        // Update divination details
        const divinationDetails = {
          firstname: user.personal_details.firstname,
          lastname: user.personal_details.lastname,
          email: user.personal_details.email,
          customer_id: res.results._id,
          affiliate_id: res.results.affiliate_id,
        };

        Cookies.set("divinationDetails", JSON.stringify(divinationDetails), {
          expires: 1,
          path: "/",
        });

        obj["customer_id"] = res.results._id;
        obj["affiliate_id"] = val.affiliate_id;
        setPersonalLoader(false);
        setPersonalFormData(obj);
        setSnackbarSeverity("success");
        setSnackbarMassage(
          "We've registered your details. Redirecting you to secure payment. Please wait..."
        );
        setSnackbarState(true);

        // Reset form fields after successful submission
        setUser({
          personal_details: {
            firstname: "",
            lastname: "",
            phone: "",
            contact_number: "",
            billingaddress: "",
            city: "",
            state: "",
            zip: "",
            country: "",
            email: "",
            password: "",
            confirm_password: "",
          },
        });

        await new Promise((resolve) => setTimeout(resolve, 2000));
        await initiateStripePayment(res.results._id, val.email, obj);
      } else {
        setSnackbarSeverity("error");
        setSnackbarState(true);
        setSnackbarMassage(res.message || "Registration failed");
        //   setPaymentStart(false)
      }
      setPersonalLoader(false);
    } catch (error) {
      setPersonalLoader(false);
      setSnackbarSeverity("error");
      setSnackbarState(true);
      setSnackbarMassage(error.message);
      //   setPaymentStart(false)
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handelsnackbarClose = () => {
    setSnackbarState(false);
    setSnackbarMassage("");
    setOpen(false);
  };

  //----------------------------stripe----------------------------------
  const handleCloseStripeModal = () => {
    setIsStripeModalOpen(false);
    setClientSecret("");
    setStripeProcessing(false);
    setStripeError(null);
  };

  const initiateStripePayment = async (customerId, email, formData) => {
    try {
      const selectedPlan = plans[selectedPlanIndex];
      const paymentPayload = {
        user_id: customerId,
        email: email,
        name: [formData.firstname, formData.lastname].filter(Boolean).join(" "),
        user_type: "is_trainee",
        amount: amountAndType.amount * 100, // converting to smallest currency unit
        currency: amountAndType.currency.toLowerCase(), // "USD" or "INR"
        plan_name: selectedPlan?.name || "Standard Plan",
        plan_id: selectedPlan?.id || selectedPlanIndex,
      };

      const paymentReq = await fetch(
        `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}payment/create-payment-intent`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(paymentPayload),
        }
      );
      const paymentRes = await paymentReq.json();
      if (
        paymentRes.status === "success" &&
        paymentRes.payment_intent?.clientSecret
      ) {
        setClientSecret(paymentRes.payment_intent.clientSecret);
        setIsStripeModalOpen(true);
      } else {
        setStripeError(
          paymentRes.message || "Failed to set up payment. Please try again."
        );
        setSnackbarSeverity("error");
        setSnackbarState(true);
        setSnackbarMassage("Failed to set up payment. Please try again.");
      }
    } catch (err) {
      setStripeError("A network error occurred while setting up payment.");
      setSnackbarSeverity("error");
      setSnackbarState(true);
      setSnackbarMassage(
        "An error occurred setting up payment. Please try again."
      );
    }
  };

  const stripePromise = loadStripe(process.env.NEXT_PUBLIC_PAYMENT_PUBLIC_KEY);

  const appearance = {
    theme: "night",
    variables: {
      colorPrimary: "#ffcc00",
      colorBackground: "#101525",
      colorText: "#ffffff",
      colorDanger: "#df1b41",
      fontFamily: "Inter, system-ui, sans-serif",
      spacingUnit: "4px",
      borderRadius: "8px",
    },
    rules: {
      ".Label": { color: "#ffcc00", fontWeight: "600" },
      ".Input": {
        backgroundColor: "rgba(255, 255, 255, 0.05)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
      },
      ".TermsText": { color: "rgba(255, 255, 255, 0.6)" },
    },
  };
  const stripeOptions = {
    clientSecret,
    appearance,
  };

  const handleStripeSubmit = async (stripe, elements) => {
    setStripeProcessing(true);
    setStripeError(null);

    const returnUrl = `${window.location.origin}/stripe_success_page_diviner`;

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: returnUrl,
      },
      redirect: "always",
    });

    if (error) {
      setStripeError(error.message);
      setStripeProcessing(false);
      setSnackbarState(true);
      setSnackbarSeverity("error");
      setSnackbarMassage(`Payment failed: ${error.message}`);
    }
  };

  return (
    <React.Fragment>
      <Head>
        <title>Checkout - Professional Divination Course | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Checkout, Enroll Now, Professional Divination Course, Astrology Course, Tarot Course, Course Payment, School of Our Divine Infinite Being"
        ></meta>
        <meta
          property="og:title"
          content="Enroll Now: Professional Divination Course Checkout"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/divination_course_checkout_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="The secure checkout page for the Professional Divination Course at the School of Our Divine Infinite Being, showing the order summary and billing form."
        ></meta>
        <meta
          property="og:description"
          content="Complete your enrollment for the Professional Divination Course. Securely enter your details to gain lifetime access to over 100 hours of Astrology and Tarot training. A 10% discount is available for full payment."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/diviner-signup"
        ></meta>
        <link rel="icon" href="/favicon.ico" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
        <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;700&family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" />

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/divination_course_checkout_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="The secure checkout page for the Professional Divination Course at the School of Our Divine Infinite Being, showing the order summary and billing form."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/diviner-signup"
        ></meta>
        <meta
          name="twitter:title"
          content="Enroll Now: Professional Divination Course Checkout"
        ></meta>
        <meta
          name="twitter:description"
          content="Complete your enrollment for the Professional Divination Course. Securely enter your details to gain lifetime access to over 100 hours of Astrology and Tarot training. A 10% discount is available for full payment."
        />
        <link rel="canonical" href="https://www.divineinfinitebeing.com/diviner-signup" />
      </Head>
      <div className={`${styles.paymentmainwrapper} banner_modal_main_new perrenial_access_bnnr_main perrenial_access_bnnr_signup`}>

        <div className="ritualpraxis_blockone">
          {/* {/ <!------Main Banner section-------> /} */}
          <div className="ritualpraxis_banner_main_wrpr">
            <div className="ritualpraxis_banner_left">
              <div className="bannerLogo">
                <div className="bnnr_img1"> <span className="logoviewlink" onClick={handleOpen}>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/viewicon.png" /> */}
                  <img
                    src={`${process.env.cloud_url2}assets/images/viewicon.png`}
                    alt="view_icon"
                  />
                </span>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" /> */}
                  <img
                    src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
                    alt="banner_logo"
                  /></div>
                <div className="bnnr_img2"><img className="astrologypro_bnnr_logo"
                  src="/image/astrologypro/astrologupro_new_logo_bnnr.webp"
                  alt="AstrologyPro" />
                </div>
              </div>
              <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
              <h1 data-text="infinite being">INFINITE BEING</h1>

               <h2>
                Polytheistic Monism - Divine Theurgy - Oracle to the Gods<br />
                Your initiation now unlocks <span className="orng_txt">AstrologyPro,</span> a unified system of advanced charts and <span>sacred insights.</span>

 
                </h2>
              <div className="ritualpraxis_bottombannerbg bannerboxtxt">
                <div className="yellow_bar"></div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.paymentsubwrapper}>
          {/* <div className={styles.pay_logowrapper}>
            <img
              // src={`${process.env.cloud_url}sign_up/divine_sign_up_logo.webp`}
              src="/image/divine_sign_up_logo_new.webp"
            />
            <h2>
              <span>SCHOOL OF THE DIVINE</span>
              <span>INFINITE BEING</span>
            </h2>
          </div> */}
          <div className={`${styles.checkout} checkOutTitle`}>
            <h1>CHECK OUT</h1>
          </div>

          <div className={styles.connectedAccessBanner}>

            <div className={styles.connectedAccessContent}>
              <h5>
                 <span>CONNECTED ACCESS</span>
              </h5>
              <p>
                <span className={styles.grey_txt}>
                  Your Diviner Academy registration also creates your AstrologyPro access.</span> <span className={styles.red_txt}>After signup,</span> <span className={styles.grey_txt}>your membership continues into the connected AstrologyPro experience.</span>
                
              </p>
            </div>

            <div className={styles.connectedAccessLogo}>
              <img
                src="/image/astrologypro/astrologypro_logo_img_new.webp"
                alt="AstrologyPro Logo"
              />
            </div>
            
          </div>

          <div className={styles.colcontainer}>
            <div className={styles.pay_formwrapper}>
              <div className={styles.graywrapper}>
                <div className={styles.quarterSelectionWrpr}>
                  <div className={styles.orangeStatic}>
                    <h3>
                      <span>
                        Get a Flat 10% instant discount on course <br />
                        fees with full payment upfront!
                      </span>
                    </h3>
                  </div>

                  <h3 className={styles.masteryText}>
                    Our full course includes the mastery of 15 Astrology and
                    Tarot products
                  </h3>

                  <div className={styles.common_header}>
                    <div className="newBlockWrprBlcok">
                      <h1>
                        Our courses are done through live web casts and student
                        center training videos and sements. You will be able to
                        collaborate live with teachers and go into break out
                        seasons with other students while enjoying full course
                        materials you gain access to for life!
                      </h1>
                    </div>
                  </div>
                  <div className={styles.greenBlockWrapper}>
                    <div className={styles.titlewrapperNew}>
                      <h4>Courses Metrics:</h4>
                    </div>
                    <div className={styles.greenMain}>
                      <div className={styles.greenMainsub}>
                        <ul>
                          <li>
                            Comprehensive and rigorous training encompassing
                            over 100 hours of in-depth study, including both
                            academic content and practical demonstrations by
                            seasoned professionals. Our evaluative process
                            allows for unlimited attempts at the examination,
                            facilitating mastery through iterative improvement.
                          </li>
                          <li>
                            Upon successful completion of the training modules
                            and certification exam, participants may choose live
                            classroom sessions that align with their personal
                            schedules.
                          </li>
                          <li>
                            The curriculum is structured into two-week segments,
                            Session A and Session B, each providing 30 hours of
                            immersive, live classroom engagement and active
                            practice alongside fellow students.
                          </li>
                          <li>
                            Participants will have the opportunity to conduct
                            over 20 live readings during these sessions,
                            ensuring they gain confidence and proficiency in the
                            application of their skills.
                          </li>
                          <li>
                            All training sessions are meticulously recorded,
                            allowing students to revisit and analyze a plethora
                            of readings conducted by peers, thereby enhancing
                            their learning curve.
                          </li>
                          <li>
                            Direct access to our expert instructors is
                            facilitated through both email correspondence and
                            scheduled one-on-one consultations, ensuring
                            personalized guidance and support.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={`${styles.pay_rightwrapper} ${styles.graywrapper2}`}>
              <div className={styles.titlewrapper}>
                <h4 style={{ fontWeight: 700 }}>ORDER SUMMARY</h4>
              </div>

              <div className={styles.rightsubwrapper}>
                <h3>Select Your Plan:</h3>
                {loadingPlans ? (
                  <Box sx={{ width: '100%', py: 4 }}>
                    <LinearProgress />
                    <Typography variant="body2" sx={{ mt: 1, color: '#ffcc00', textAlign: 'center' }}>
                      Loading latest plans...
                    </Typography>
                  </Box>
                ) : (
                  <div className={styles.planSelectionGrid}>
                    {plans.map((plan, index) => {
                      const planAmount = plan.amount;
                      const planMrp = plan.mrp;
                      const planCurrency = plan.currency || "USD";
                      const discountPct = planMrp > planAmount
                        ? Math.round(((planMrp - planAmount) / planMrp) * 100)
                        : 0;

                      const formatCurrency = (val) =>
                        new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: planCurrency,
                        }).format(val) + ` (${planCurrency})`;

                      return (
                        <div
                          key={index}
                          className={`${styles.planCard} ${selectedPlanIndex === index ? styles.activePlan : ""}`}
                          onClick={() => {
                            setSelectedPlanIndex(index);
                            setAmountAndType({
                              type: "Full",
                              amount: planAmount,
                              currency: planCurrency,
                            });
                          }}
                        >
                          <div className={styles.planCardTop}>
                            <div className={`${styles.planRadio} ${selectedPlanIndex === index ? styles.planRadioActive : ""}`} />
                            <div className={styles.planCardInfo}>
                              <h4>{plan.name}</h4>
                              {plan.description && plan.description !== plan.name && (
                                <p>{plan.description}</p>
                              )}
                            </div>
                            <div className={styles.planPriceBlock}>
                              <span className={styles.planPrice}>{formatCurrency(planAmount)}</span>
                              {planMrp > planAmount && (
                                <>
                                  <span className={styles.planMrp}>{formatCurrency(planMrp)}</span>
                                  <span className={styles.planDiscount}>{discountPct}% OFF</span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}


              </div>




              <div className={`${styles.titlewrapper} ${styles.fittitle}`}>
                <h4>Billing details</h4>
              </div>
              <div className="payment_formwrapper">
                {/* <form > */}
                <div className={styles.rightsubwrapper}>
                  <div className="form-input-wrapper">
                    <TextField
                      className={`${styles.from_input} ${styles.form_field_wrapperfname}`}
                      name="firstname"
                      value={
                        user?.personal_details.firstname
                          ? user.personal_details.firstname
                          : ""
                      }
                      onChange={handleInput}
                      error={error.firstname ? true : false}
                      helperText={error.firstname}
                      onKeyDown={() => {
                        error.firstname = "";
                      }}
                      variant="outlined"
                      label="First Name"
                    />
                  </div>

                  <div className="form-input-wrapper">
                    <TextField
                      className={`${styles.from_input} ${styles.form_field_wrapperlname}`}
                      name="lastname"
                      value={
                        user?.personal_details.lastname
                          ? user.personal_details.lastname
                          : ""
                      }
                      onChange={handleInput}
                      error={error?.lastname ? true : false}
                      helperText={error.lastname}
                      onKeyDown={() => {
                        error.lastname = "";
                      }}
                      variant="outlined"
                      label="Last Name"
                    />
                  </div>

                  <div className="form-input-wrapper">
                    <TextField
                      label="Phone No"
                      className={`${styles.from_input} `}
                      variant="outlined"
                      fullWidth={true}
                      name="phone"
                      type="text"
                      onKeyPress={(e) => {
                        error.phone = "";
                        if (e.which < 48 || e.which > 57) {
                          e.preventDefault();
                        } else {
                          let input = e.target.value;
                          let result = input.replace(/\D/g, "");
                        }
                      }}
                      onChange={(e) => phoneFormatting(e)}
                      value={user?.personal_details.phone}
                      error={error?.phone ? true : false}
                      helperText={error?.phone}
                    />
                  </div>

                  <div className="form-input-wrapper input-full-width">
                    <TextField
                      className={`${styles.from_input} ${styles.form_field_wrapperfname}`}
                      name="billingaddress"
                      value={
                        user?.personal_details.billingaddress
                          ? user.personal_details.billingaddress
                          : ""
                      }
                      onChange={handleInput}
                      error={error.billingaddress ? true : false}
                      helperText={error.billingaddress}
                      onKeyDown={() => {
                        error.billingaddress = "";
                      }}
                      variant="outlined"
                      label="Billing Address:"
                    />
                  </div>

                  <div className="form-input-wrapper">
                    <TextField
                      label="City"
                      className={`${styles.from_input} `}
                      name="city"
                      value={
                        user?.personal_details.city
                          ? user.personal_details.city
                          : ""
                      }
                      onChange={handleInput}
                      error={error.city ? true : false}
                      helperText={error.city}
                      onKeyDown={() => {
                        error.city = "";
                      }}
                      variant="outlined"
                    />
                  </div>

                  <div className="form-input-wrapper">
                    <TextField
                      select
                      label="Country"
                      className={`${styles.from_input}`}
                      name="country"
                      value={user?.personal_details.country || ""}
                      onChange={handleInput}
                      error={!!error.country}
                      helperText={error.country}
                      onKeyDown={() => {
                        error.country = "";
                      }}
                      variant="outlined"
                    >
                      {/* <MenuItem value="USA">USA</MenuItem>
                        <MenuItem value="India">India</MenuItem> */}

                      {countries.map((country) => (
                        <MenuItem key={country.code} value={country.name}>
                          {country.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>

                  <div className="form-input-wrapper">
                    <FormControl
                      className={`${styles.from_input} form_field_wrapperstate`}
                    >
                      {["India", "USA"].includes(
                        user?.personal_details.country
                      ) ? (
                        <>
                          <InputLabel id="demo-simple-select-helper-label">
                            Select State
                          </InputLabel>
                          <Select
                            className="contact_select_menu"
                            id="demo-simple-select-helper"
                            label="Select State"
                            name="state"
                            onChange={handleInput}
                            value={user?.personal_details.state || ""}
                            error={!!error.state}
                            onKeyDown={() => {
                              error.state = "";
                            }}
                          >
                            {stateJson.map((item, key) => (
                              <MenuItem
                                className="contact_menu_item"
                                value={item.name}
                                key={key}
                              >
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </>
                      ) : (
                        <TextField
                          className="contact_select_menu"
                          label="State / Province / Region"
                          name="state"
                          onChange={handleInput}
                          value={user?.personal_details.state || ""}
                          error={!!error.state}
                          // helperText={error.state}
                          onKeyDown={() => {
                            error.state = "";
                          }}
                          variant="outlined"
                        />
                      )}

                      {error.state && (
                        <FormHelperText id="my-helper-text">
                          {error.state}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </div>

                  <div className="form-input-wrapper">
                    <TextField
                      label="Zip"
                      className={`${styles.from_input} `}
                      name="zip"
                      value={
                        user?.personal_details.zip
                          ? user.personal_details.zip
                          : ""
                      }
                      onChange={handleInput}
                      error={error.zip ? true : false}
                      helperText={error.zip}
                      onKeyDown={() => {
                        error.zip = "";
                      }}
                      variant="outlined"
                    />
                  </div>

                  <div className="form-input-wrapper">
                    <TextField
                      className={`${styles.from_input} `}
                      name="email"
                      value={
                        user?.personal_details.email
                          ? user.personal_details.email
                          : ""
                      }
                      onChange={handleInput}
                      error={error.email ? true : false}
                      helperText={error.email}
                      onKeyDown={() => {
                        error.email = "";
                      }}
                      variant="outlined"
                      label="Email"
                    />
                  </div>

                  <div className="form-input-wrapper">
                    <TextField
                      className={`${styles.from_input} `}
                      name="password"
                      value={
                        user?.personal_details.password
                          ? user.personal_details.password
                          : ""
                      }
                      onChange={handleInput}
                      error={error.password ? true : false}
                      helperText={error.password}
                      onKeyDown={() => {
                        error.password = "";
                      }}
                      variant="outlined"
                      label="Password"
                      type={passwordVition ? "text" : "password"}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{ cursor: "pointer" }}
                          >
                            {passwordVition ? (
                              <Visibility
                                onClick={() => setPasswardVition(false)}
                              />
                            ) : (
                              <VisibilityOff
                                onClick={() => setPasswardVition(true)}
                              />
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>

                  <div className="form-input-wrapper">
                    <TextField
                      className={`${styles.from_input} `}
                      name="confirm_password"
                      value={
                        user?.personal_details.confirm_password
                          ? user.personal_details.confirm_password
                          : ""
                      }
                      onChange={handleInput}
                      error={error.confirm_password ? true : false}
                      helperText={error.confirm_password}
                      onKeyDown={() => {
                        error.confirm_password = "";
                      }}
                      variant="outlined"
                      label="Confirm Password"
                      type={con_passwordVition ? "text" : "password"}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{ cursor: "pointer" }}
                          >
                            {con_passwordVition ? (
                              <Visibility
                                onClick={() => setCon_PasswardVition(false)}
                              />
                            ) : (
                              <VisibilityOff
                                onClick={() => setCon_PasswardVition(true)}
                              />
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>

                <div className={styles.border}></div>

                <Button
                  className={`${styles.button} ${styles.submitbtnsection}`}
                  variant="contained"
                  onClick={handleSubmit}
                >
                  SUBMIT
                </Button>
                {personalLoader ? (
                  <>
                    <br />
                    <LinearProgress />
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>

        <Snackbar
          open={snackbarState}
          autoHideDuration={4000}
          onClose={handelsnackbarClose}
          className="snackbarClass"
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={handelsnackbarClose}
            severity={snackbarSeverity || "error"}
            sx={{ width: "100%" }}
          >
            {snackbarMassage}
          </Alert>
        </Snackbar>

        <Modal
          open={isStripeModalOpen}
          onClose={handleCloseStripeModal}
          aria-labelledby="stripe-payment-modal-title"
          aria-describedby="stripe-payment-modal-description"
          className="banner_modal_main banner_modal_main_new banner_modal_main_new1"
        >
          <div className="main_wrpr_finddivine main_wrpr_payment_modal">
            <span className="close_btn" onClick={handleCloseStripeModal}>
              <CloseIcon />
            </span>

            <Box className="banner_modal_box_new banner_modal_box_neww">
              <Typography
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className="modal_banner_new"
                component="div"
              >
                <div className="sub_modal_banner_new">
                  <div className="gred_txt">
                    <h3>
                      <span>Complete Your Payment</span>
                    </h3>
                  </div>

                  <Typography
                    id="stripe-payment-modal-description"
                    sx={{ lineHeight: "30px !important" }}
                    className="price_pera_panalium_mendalitiom"
                  >
                    Total Amount: {amountAndType.type} -{" "}
                    {new Intl.NumberFormat("en-IN", {
                      style: "currency",
                      currency: amountAndType.currency === "INR" ? "INR" : "USD",
                    }).format(amountAndType.amount)}
                    {amountAndType.currency === "INR" ? " (INR)" : "(USD)"}
                  </Typography>

                  {clientSecret && (
                    <Elements options={stripeOptions} stripe={stripePromise}>
                      <StripePaymentModal
                        clientSecret={clientSecret}
                        onSubmit={handleStripeSubmit}
                        processing={stripeProcessing}
                        error={stripeError}
                      />
                    </Elements>
                  )}
                </div>
              </Typography>
            </Box>
          </div>
        </Modal>
      </div>
      <Modal
              open={open}
              onClose={handleCloseNew}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="banner_modal_main"
            >
              <Box className="banner_modal_box">
                <Typography
                  id="modal-modal-description"
                  component="div"
                  sx={{ mt: 2 }}
                  className="modal_banner"
                >
                  <div className="sub_modal_banner">
                    <span className="close_btn" onClick={handleCloseNew}>
                      <CloseIcon />
                    </span>
                    <img
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                      alt="bannerLogo"
                    />
                  </div>
                </Typography>
              </Box>
            </Modal>
    </React.Fragment>
  );
};

export default DivinerSighnUp;
